import type { RichOrderItem } from '@ps/api/types';

import { nicknameWithInitial } from '../../../../orders/functions/nicknameWithInitial';
import {
  orderProductImage,
  orderProductName,
} from '../../../../orders/functions/orderRowDisplay';
import type { OrderMode } from '../../../../orders/types';
import type { OrderContent } from '../../../types/ChatMessage';

/**
 * Map a searched order into the `OrderContent` a shared-order chat
 * message carries. 1:1 with PopshopRN's `shareOrder` payload build:
 * price/quantity are the slave-order-inclusive totals, and `from`
 * records which side of the conversation shared it so the bubble
 * shows the correct party name.
 */
export function orderItemToOrderContent(
  item: RichOrderItem,
  role: OrderMode,
): OrderContent {
  return {
    orderId: item.id,
    orderNumber: item.orderNumber,
    imageUrl: orderProductImage(item) ?? '',
    orderTitle: orderProductName(item),
    price: item.totalPriceIncludeSlaveOrders,
    quantity: item.totalQuantitiesIncludeSlaveOrders,
    sellerId: item.sellerId,
    sellerName: nicknameWithInitial(item.seller),
    buyerId: item.buyerId,
    buyerName: nicknameWithInitial(item.buyer),
    orderDate: item.createdAt,
    from: role === 'seller' ? 'seller' : 'buyer',
  };
}
